import React from 'react'
import View from '../View'
import Upload from '../Upload'

export default ()=>{




    return (
        <div className="col s12 m6" style={{ marginTop: "0.9rem" }}>
            <View/>
            <Upload/>
        </div>
    )
}